import { useResponsive } from '@/hooks/use-responsive';

import { InvestorDetailsPacingTabCommitmentPlansQuery } from '@/__generated__/graphql';
import { Loader } from '@/components/loaders/loader';
import { TableBodyWrapper, TableWrapper } from '@/components/table/styles';
import TableHeader from '@/components/table/tableHeader';
import { IItems, ISort } from '@/components/table/types';
import { columns } from '../constants';
import AllCommitmentPlansMobileTable from './mobileTable';
import AllCommitmentPlansTableBody from './tableBody';

interface AllCommitmentPlansTableProps {
  tableRows: InvestorDetailsPacingTabCommitmentPlansQuery['commitmentPlans']['data'];
  loading: boolean;
  sort: ISort;
  updateLoading: boolean;
  currentRow: InvestorDetailsPacingTabCommitmentPlansQuery['commitmentPlans']['data'][number] | null;
  setSort: (value: ISort) => void;
  dropdownActions: (row: InvestorDetailsPacingTabCommitmentPlansQuery['commitmentPlans']['data'][number]) => IItems[];
}

const AllCommitmentPlansTable = ({ tableRows, loading, sort, updateLoading, currentRow, setSort, dropdownActions }: AllCommitmentPlansTableProps) => {
  const { isMobile } = useResponsive();

  return (
    <TableWrapper padding="0">
      {isMobile ? (
        <>
          {loading ? (
            <Loader />
          ) : (
            <AllCommitmentPlansMobileTable
              tableRows={tableRows}
              updateLoading={updateLoading}
              currentRow={currentRow}
              dropdownActions={dropdownActions}
            />
          )}
        </>
      ) : (
        <>
          <TableHeader refetch={() => {}} columns={columns} savedSort={sort} savedSetSort={setSort} />
          <TableBodyWrapper>
            {loading ? (
              <Loader />
            ) : (
              <AllCommitmentPlansTableBody
                tableRows={tableRows}
                updateLoading={updateLoading}
                currentRow={currentRow}
                dropdownActions={dropdownActions}
              />
            )}
          </TableBodyWrapper>
        </>
      )}
    </TableWrapper>
  );
};

export default AllCommitmentPlansTable;
